module.exports = __webpack_public_path__ + "media/images/city/072-quezon-memorial-circle-502acf1e5e712a8891cbd0bed88c34bc.svg";